<div class="dialog-header">
  <h2>{{ data.tipo === "orden" ? "Crear orden digital" : data.tipo === "receta" ? "Crear receta digital" : data.tipo === "odontograma" ? "Cargar odontograma" : "Crear estudio medico" }}</h2>
  <button mat-icon-button (click)="dialogRef.close(false)">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <app-form-estudios-medicos
    *ngIf="data.tipo === 'estudio'"
    [response]="data.formData"
    [editar]="false"
    [medicoSection]="true"
    (listar)="onListar()"
  ></app-form-estudios-medicos>

  <app-emitir-receta
    *ngIf="data.tipo === 'receta'"
    [pacienteInput]="pacienteData"
    [centroMedicoIdInput]="centroMedicoId"
    [modoDialog]="true"
    (recetaCreada)="onRecetaCreada($event)"
  ></app-emitir-receta>

  <app-crear-orden
    *ngIf="data.tipo === 'orden'"
    [pacienteInput]="pacienteData"
    [centroMedicoIdInput]="centroMedicoId"
    [modoDialog]="true"
    (ordenCreada)="onOrdenCreada($event)"
  ></app-crear-orden>

  <app-crear-odontograma
    *ngIf="data.tipo === 'odontograma'"
    [pacienteId]="pacienteData?.id"
    [medicoId]="medicoId"
    [centroMedicoId]="centroMedicoId"
    (odontogramaCreado)="onOdontogramaCreado($event)"
  ></app-crear-odontograma>
</mat-dialog-content>
